import { DataTable } from '@/components/ui/DataTable'
import { useRestClient } from '@/contexts/QueryProvider'
import { ApplicationsBreadcrumb } from '../ApplicationsBreadcrumbs'
import { useCurrentApplication } from '../useCurrentApplication'
import { appRolesColumns } from './AppRolesTable/appRolesColumns'
import { ApplicationRoleForm } from '../Forms/ApplicationRoleForm'
import { Button } from '@/components/shadcn/button'
import { IconPlusOutline } from '@icons/IconPlusOutline'
import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { Suspense } from 'react'
import { DataTableLoading } from '@/catalog-apps/components/component-library/DataTableComponent'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'

export type LabelValueCell = {
  label: string
  value: string
}

export type NumberValueCell = {
  label: number
  value: number
}

export type ApplicationRoleItem = {
  applicationId: number
  id: number

  name: LabelValueCell
  description: LabelValueCell

  memberCount: NumberValueCell
  teamCount: NumberValueCell
}

export const AppRolesPage = () => {
  return (
    <>
      <ApplicationsBreadcrumb title="Roles" />
      <QueryErrorBoundary errorMessage="Failed to fetch roles">
        <Suspense fallback={<DataTableLoading />}>
          <AppRolesPageContent />
        </Suspense>
      </QueryErrorBoundary>
    </>
  )
}

function AppRolesPageContent() {
  const { applicationId } = useCurrentApplication()
  const { getApplicationsApiListApplicationRoles } = useRestClient()
  const { data: items } = getApplicationsApiListApplicationRoles.useSuspenseQuery(
    {
      query: { applicationId },
    },
    {
      select: (data) =>
        data.map((role) => {
          return {
            id: role.id,
            applicationId: role.applicationId,

            name: { label: role.name, value: role.name },
            description: { label: role.description, value: role.description },

            memberCount: { label: role.memberCount, value: role.memberCount },
            teamCount: { label: role.teamCount, value: role.teamCount },
          } as ApplicationRoleItem
        }),
    }
  )

  return (
    <TablePageContainer>
      <DataTable
        columns={appRolesColumns}
        data={items}
        action={
          <ApplicationRoleForm
            sheetTitle="Add a role"
            sheetTrigger={
              <Button size="sm" variant="outline">
                <IconPlusOutline className="mr-2" />
                Add role
              </Button>
            }
          />
        }
      />
    </TablePageContainer>
  )
}
